import { useCallback } from 'react';
import api from '@/api/api';
import { displayError } from '../error/errorHandler';

interface UseFileUploadReturnType {
  handleSubmit: (
    file: File,
    name: string,
    details?: Map<string, any>
  ) => Promise<void>;
}

export const useFileUpload = (uploadUrl: string): UseFileUploadReturnType => {
  const handleSubmit = useCallback(
    async (file: File, name: string, details?: Map<string, any>) => {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('file', file);
      // TODO: add details (e.g. for employee attachment it is expirationDate, signatureDate, serviceId, type)

      try {
        const response = await api.post(uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.info('File uploaded successfully', response.data);
      } catch (error) {
        displayError(error);
      }
    },
    [uploadUrl]
  );

  return {
    handleSubmit,
  };
};
